import Model, { attr, belongsTo } from "@ember-data/model";
import type Store from "@ember-data/store";
import { service } from "@ember/service";
import type Loinc from "parog-web/models/loinc";

export default class LoincQualitativeValue extends Model {
  @service declare store: Store;

  @attr("string") declare authorizedValue: string;
  @belongsTo("loinc", {
    async: false,
    inverse: "loincQualitativeValues"
  })
  declare loinc: Loinc;
  @attr("string") declare translationFr: string;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "loinc-qualitative-value": LoincQualitativeValue;
  }
}
